// extracted by mini-css-extract-plugin
module.exports = {"content":"WeatherAndEnergyConsumptionContainer_content__3gE-q","headerContainer":"WeatherAndEnergyConsumptionContainer_headerContainer__xOtpJ"};